import { signal } from 'services/SignalsService'

const name = 'WIN-MULTIPLY'

function execute() {
  const winModel = game.models.WinModel.get()

  if (!winModel.multiply.layoutx) {
    return Promise.resolve()
  }

  const type = 'multiply'
  const amount = winModel.multiply.win

  signal.dispatch('WIN-ANIMATE', type)
  signal.dispatch('WIN-COLLECT', { type, amount })

  return signal.promise('WIN-ANIMATE:DONE')
}

export function getWinMultiplyAction() {
  return {
    name,
    execute,
  }
}
